import React, { useState } from 'react';
import { DialogArticle } from '../DialogArticle/DialogArticle';
import S from './InternalDialogArticle.styles';

export const InternalDialogArticle = ({ slug, text }: { slug: string; text: string }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [dialogRendered, setDialogRendered] = useState<boolean>(false);

  const onClick = () => {
    setOpen(true);
    setDialogRendered(true);
  };

  return (
    <>
      <S.StyledButton onClick={onClick} type="button">
        {text}
      </S.StyledButton>
      {dialogRendered && <DialogArticle isOpen={open} setIsOpen={setOpen} slug={slug} />}
    </>
  );
};
